import React from 'react';
import { useTranslation } from 'react-i18next';
import SyntaxHighlightInput from './SyntaxHighlightInput';
import CompactSelectPicker from './CompactSelectPicker';

const KEY_INPUT_CLASS =
  'url-input request-url-bar__url-input border-0 rounded-none focus:outline-none min-h-0 bg-transparent w-full';
const KEY_INPUT_STYLE = { minHeight: '36px' };

export default function FormDataKeyField({
  fieldType = 'text',
  onTypeChange,
  keyValue = '',
  onKeyChange,
  keyPlaceholder,
  variableProps,
}) {
  const { t } = useTranslation();
  const type = fieldType === 'file' ? 'file' : 'text';

  const typeOptions = [
    { value: 'text', label: t('request.formDataText') },
    { value: 'file', label: t('request.formDataFile') },
  ];

  return (
    <div className="request-url-field-group url-container flex w-full min-w-0 rounded-lg border border-gray-200 overflow-hidden bg-white dark:border-zinc-700 dark:bg-zinc-900">
      {onTypeChange ? (
        <div className="form-data-type-wrap auth-picker-field-wrap relative flex flex-shrink-0 items-stretch bg-white dark:bg-[#161618]">
          <CompactSelectPicker
            value={type}
            onChange={onTypeChange}
            options={typeOptions}
            aria-label={t('request.formDataFieldType')}
            className="w-full h-full"
          />
        </div>
      ) : null}
      <div className="url-container__url min-w-0 flex-1 flex flex-col justify-center bg-white dark:bg-[#161618]">
        <SyntaxHighlightInput
          placeholder={keyPlaceholder ?? t('request.key')}
          value={keyValue}
          onChange={onKeyChange}
          className={KEY_INPUT_CLASS}
          style={KEY_INPUT_STYLE}
          {...variableProps}
        />
      </div>
    </div>
  );
}
